import React, { Fragment, useContext, useEffect, useState } from "react";
import {
  BackgroundDiv,
  BottomBtnArea,
  ContentBody,
  HeaderTitle,
} from "./ReceiptStyle";

import styled from "styled-components";
import { Button } from "../../../components";
import { AppContext } from "../../../components/AppProvider";
import ToastMsg, {
  toastMsgObj,
} from "../../../components/UI/Layer/ToastMsg/ToastMsg";
import { PostApi1976 } from "../../../modules/network/padoPost";
import { IC } from "../../../resources/Assets";
import Management from "../../Family/Management";
import ReceiptTargetInfo from "./ReceiptTargetInfo";
import TargetManagement from "./ReceiptTargetManagement";
import { setIdCard } from "../Interface/NFTF/NativeApi";

const ReceiptTarget = props => {
  const {
    trgtInfo,
    setTrgtInfo,
    setPageIdx,
    backStep,
    fileTemp,
    setFileTemp,
    imgTempView,
    setImgTempView,
    seqNo,
    setBackStep,

    familyInfo,
    setFamilyInfo,
  } = props;
  const { userinfo, phonecfg, cfg } = useContext(AppContext);
  const [viewMsgLayer, setViewMsgLayer] = useState(false);
  const [rqstRelCd, setRqstRelCd] = useState("PRCP");
  const [famzSeqNo, setFamzSeqNo] = useState("");

  const [familyList, setFamilyList] = useState();

  const [pageType, setPageType] = useState("default");

  // const [toastView, setToastView] = useState(false);
  const [toastView, setToastView] = useState({
    view: false,
    msgType: "famzAdd",
  });

  const submit = () => {
    // 중복 등록여부 체크 로직 추가
    setTrgtInfo({
      rqstRelCd: rqstRelCd,
      famzSeqNo: famzSeqNo,
      file: fileTemp.file,
      fileName: fileTemp.fileName,
    });

    setIdCard(fileTemp.file, familyInfo.famzFileNm);
    if (backStep) {
      setPageIdx(1);
    } else {
      setBackStep(true);
      setPageIdx(7);
    }
  };

  const getFamilyList = () => {
    PostApi1976(userinfo, cfg, phonecfg)
      .then(res => {
        setFamilyList(res.result);
      })
      .catch(err => {
        console.log("ERR getFamilyList:: ", err);
      });
  };

  useEffect(() => {
    getFamilyList();
    props.setMsgState("target");
  }, [pageType]);

  useEffect(() => {
    toastView.view &&
      setTimeout(() => {
        // setToastView(false);
        setToastView({
          view: false,
          msgType: "famzAdd",
        });
      }, 5000);
  }, [toastView]);

  // 이미 등록된 사용자인지 체크하는 인터페이스 필요
  // hpKey, 진료 대상자 정보(저장시 체크)

  return (
    <Fragment>
      {pageType === "default" && (
        <BackgroundDiv>
          <HeaderTitle>
            <div
              style={{ width: "40px", height: "40px" }}
              onClick={() => {
                setImgTempView(0);
                // props.setPageIdx(backStep ? 1 : 4);
                props.setPageIdx(1);
              }}>
              <img src={IC.etc.ICON_CHEVRON_LEFT} />
            </div>
            <div>{props.hederTitle}</div>
            <div style={{ width: "40px", height: "40px" }}></div>
          </HeaderTitle>
          <ContentBody style={{ gap: "8px" }}>
            <ContentsHeader>진료 대상자</ContentsHeader>

            <div style={{ width: "100%" }}>
              <ReceiptTargetInfo
                setPageType={setPageType}
                fileTemp={fileTemp}
                setFileTemp={setFileTemp}
                familyInfo={familyInfo}
              />
            </div>
          </ContentBody>
          <BottomBtnArea>
            <Button
              severity="primary"
              disable={"off"}
              clickEvent={() =>
                fileTemp && fileTemp.file != ""
                  ? submit()
                  : props.setViewMsgLayer(true)
              }>
              {backStep ? "저장" : "저장 후 다음"}
            </Button>
          </BottomBtnArea>
        </BackgroundDiv>
      )}
      {pageType === "list" && (
        <TargetManagement
          setPageType={setPageType}
          setRqstRelCd={setRqstRelCd}
          setFamzSeqNo={setFamzSeqNo}
          famzSeqNo={famzSeqNo}
          familyInfo={familyInfo}
          setFamilyInfo={setFamilyInfo}
          familyList={familyList}
        />
      )}
      {pageType === "add" && (
        <Management
          setPageType={setPageType}
          pageType={pageType}
          familyList={familyList}
          setToastView={setToastView}
        />
      )}
      {toastView.view && (
        <div style={{ paddingLeft: "20px", willChange: "transform" }}>
          <ToastMsg
            option={{
              img: IC.check.ICON_GREEN_CHECK,
              bottom: "0px",
              text: toastMsgObj[toastView.msgType].text,
            }}
          />
        </div>
      )}
    </Fragment>
  );
};

const ContentsHeader = styled.div`
  height: 22px;
  flex-grow: 1;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.57;
  letter-spacing: -0.28px;
  text-align: left;
  color: #333;
`;

export default ReceiptTarget;
